module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-07.fd9b949f.png";